<app-slide-in-modal #modal>
  <ng-container title i18n>Ajouter un document</ng-container>
  <div body>
    <form
      [formGroup]="formGroup"
      class="lty-form"
      id="documentUploadForm"
      (ngSubmit)="submit()"
    >
      <div class="modal-body">
        <div class="split-form-body">
          <div *ngIf="!hideCustomerFields" class="form-group flex-basis-50">
            <label i18n>Client <sup>*</sup></label>
            <div>
              <mat-form-field class="lty-input">
                <mat-select
                  [ngClass]="{ 'mat-select-no-arrow': userInputDisabled }"
                  formControlName="userId"
                >
                  <mat-option
                    *ngFor="let user of users"
                    [value]="user.userId"
                    >{{
                      user.firstName +
                        '
                                        ' +
                        user.lastName
                    }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  formGroup.controls['userId'].touched &&
                  formGroup.controls['userId'].invalid
                "
                class="invalid-feedback"
              >
                <div
                  *ngIf="
                    formGroup.controls['userId'].errors &&
                    formGroup.controls['userId'].errors['required']
                  "
                  i18n
                >
                  L'utilisateur est requis
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!hideCustomerFields" class="form-group flex-basis-50">
            <label i18n>Membre de la famille <sup>*</sup></label>
            <div>
              <mat-form-field class="lty-input">
                <mat-select
                  [ngClass]="{ 'mat-select-no-arrow': memberInputDisabled }"
                  formControlName="memberId"
                >
                  <mat-option
                    *ngFor="let member of familyMembers"
                    [value]="member.familyMemberId"
                    >{{ member.firstName + ' ' + member.lastName }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  formGroup.controls['memberId'].touched &&
                  formGroup.controls['memberId'].invalid
                "
                class="invalid-feedback"
              >
                <div
                  *ngIf="
                    formGroup.controls['memberId'].errors &&
                    formGroup.controls['memberId'].errors['required']
                  "
                  i18n
                >
                  Le membre de famille est requis.
                </div>
              </div>
            </div>
          </div>
          <div class="form-group flex-basis-100">
            <label i18n>Nom du document</label>
            <input type="text" class="form-control" formControlName="docName" />
          </div>
          <div class="form-group flex-basis-100">
            <label i18n>Type de document</label>
            <div>
              <mat-form-field class="lty-input">
                <mat-select formControlName="type">
                  <mat-option
                    *ngFor="let type of documentTypeValues"
                    [value]="type"
                    >{{ getDocumentTypeLabel(type) }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="form-group flex-basis-100">
            <div class="form-check ps-0">
              <input
                class="form-check-input"
                type="checkbox"
                id="document-upload-notify-customer"
                formControlName="notifyCustomer"
              />
              <label
                class="form-check-label"
                for="document-upload-notify-customer"
                i18n
                >Notifier le client</label
              >
            </div>
          </div>
          <div class="form-group flex-basis-100">
            <label class="file-label" i18n>Document</label>
            <div class="file alternate">
              <input
                type="file"
                id="file"
                class="file-input"
                (change)="onFileUpload($event)"
              />
              <div class="upload-icon">
                <app-upload-cloud-icon
                  height="20px"
                  width="20px"
                  color="var(--gray-600)"
                />
              </div>
              <span
                ><span class="highlighted-text" i18n
                  >Cliquez pour télécharger
                </span>
                <ng-container i18n>ou glissez un fichier</ng-container></span
              >
            </div>
            <div *ngIf="uploadedFile" class="mt-28">
              <span class="mb-16 file-label" i18n>Document téléchargé</span>
              <div class="uploaded-file-container">
                <div class="uploaded-file-element">
                  <app-file-icon
                    height="20px"
                    width="20px"
                    color="var(--gray-400)"
                  />
                  <div class="file-name">
                    <span>{{ uploadedFile.name }}</span>
                    <span>{{ uploadedFile.size | fileSize: 1 }}</span>
                  </div>
                  <app-check-circle-icon
                    height="16px"
                    width="16px"
                    color="var(--success-500)"
                  />
                </div>
                <app-trash-icon
                  class="clickable"
                  (click)="uploadedFile = undefined"
                  height="24px"
                  width="24px"
                  color="var(--gray-400)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-submit-buttons" footer>
    <button
      type="button"
      class="lty-btn lty-btn-white ms-auto"
      (click)="closeModal()"
      [disabled]="submitted"
      i18n
    >
      Annuler
    </button>
    <button
      form="documentUploadForm"
      type="submit"
      [disabled]="formGroup.invalid || !uploadedFile || submitted"
      class="lty-btn lty-btn-primary"
      i18n
    >
      Ajouter
    </button>
  </div>
</app-slide-in-modal>
